import moment from "moment";

export const formatDate = (date, format = "DD MMM YYYY") => {
  if (!date || !moment(date).isValid()) return "";
  const m = moment(date);
  return m.format(format);
};

export const formatTime = (date) => {
  if (!date || !moment(date).isValid()) return "";
  const m = moment(date);
  return m.format("hh:mm A");
};

